import { ETransactionAction } from '@xeppt/xeppt-sdk/types/transaction';
import { ETransactionMethod } from '@xeppt/xeppt-sdk/types';

export const transactionsActionsFilterArray = (t: (val: string) => string) => [
    {
        label: 'Refund',
        action: ETransactionAction.REFUND
    },
    {
        label: 'Card orders',
        action: ETransactionAction.CARD_SERVICE
    },
    {
        label: 'Send money',
        action: ETransactionAction.TRANSFER
    },
    {
        label: 'Cashback',
        action: ETransactionAction.CASHBACK
    },
    {
        label: 'Load balance',
        action: ETransactionAction.DEPOSIT
    },
    {
        label: 'Send money to Bank account',
        action: ETransactionAction.WITHDRAW
    },
    {
        label: 'Request money',
        action: ETransactionAction.REQUEST
    },
    {
        label: 'Load card balance',
        action: ETransactionAction.CARD_DEPOSIT
    },
    {
        label: 'Card purchase',
        action: ETransactionAction.CARD_TANSACTION
    },
    {
        label: 'Issue gift card',
        action: ETransactionAction.GIFT_CARD
    },
    {
        label: 'Redeem gift card',
        action: ETransactionAction.GIFT_CARD_REDEEM
    },
    {
        label: 'Reserve funds',
        action: ETransactionAction.GIFT_CARD_RESERVE
    }
];
export const transactionsMethodsFilterArray = (t: (val: string) => string) => [
    {
        label: 'Wallet',
        method: ETransactionMethod.WALLET
    },
    // {
    //     label: 'Linked card',
    //     method: ETransactionMethod.EPS
    // },
    {
        label: 'Bank account',
        method: ETransactionMethod.EFT
    },
    {
        label: 'E-Transfer',
        method: ETransactionMethod.E_TRANSFER
    },
    {
        label: 'Bill payment',
        method: ETransactionMethod.PAY_BILL
    },
    {
        label: 'Prepaid card',
        method: ETransactionMethod.CARD
    },
    {
        label: 'Gift card',
        method: ETransactionMethod.GIFT_CARD
    }
];
